import { render, staticRenderFns } from "./Marks.vue?vue&type=template&id=68ee3e28&"
import script from "./Marks.vue?vue&type=script&lang=js&"
export * from "./Marks.vue?vue&type=script&lang=js&"
import style0 from "./Marks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports